import { c as _c } from "react/compiler-runtime";
import { Badge, Box, Field, HStack, Icon, IconButton, Text, VStack, Wrap } from '@chakra-ui/react';
import { SelectableButtons } from '@src/components/sco/SelectableButtons';
import { ReactNode, useMemo } from 'react';
import { LuCheck, LuPlus, LuX } from 'react-icons/lu';
export const PRESET_TAG_CHIP_PROPS = {
  iconPlacement: 'left' as const,
  icons: {
    default: LuPlus,
    selected: LuCheck
  },
  buttonProps: {
    paddingY: 2
  }
};
export type PresetTagPickerProps = {
  addedLabel?: string;
  addHelperText?: string;
  addLabel?: string;
  disabled?: boolean;
  disabledText?: string;
  max?: number;
  onChange: (next: string[]) => void;
  renderCombobox?: (args: {
    add: (title: string) => void;
    atLimit: boolean;
  }) => ReactNode;
  selected: string[];
  suggested: string[];
  suggestedLabel?: string;
};

/**
 * Shared multi-select: preset chips (`SelectableButtons`) plus an optional tag
 * combobox for anything outside that short list. Same structure as the advisor
 * application skill picker.
 */
export const PresetTagPicker = t0 => {
  const $ = _c(59);
  const {
    addedLabel: t1,
    addHelperText,
    addLabel,
    disabled,
    disabledText,
    max,
    onChange,
    renderCombobox,
    selected,
    suggested,
    suggestedLabel: t2
  } = t0;
  const addedLabel = t1 === undefined ? "Your added tags" : t1;
  const suggestedLabel = t2 === undefined ? "Suggested" : t2;
  const atLimit = typeof max === "number" && selected.length >= max;
  let t3;
  if ($[0] !== suggested) {
    t3 = new Set(suggested);
    $[0] = suggested;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const suggestedSet = t3;
  let t4;
  if ($[2] !== selected || $[3] !== suggestedSet) {
    let t5;
    if ($[5] !== suggestedSet) {
      t5 = tag => !suggestedSet.has(tag);
      $[5] = suggestedSet;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t4 = selected.filter(t5);
    $[2] = selected;
    $[3] = suggestedSet;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const customTags = t4;
  let t5;
  if ($[7] !== selected || $[8] !== suggestedSet) {
    let t6;
    if ($[10] !== suggestedSet) {
      t6 = tag_0 => suggestedSet.has(tag_0);
      $[10] = suggestedSet;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t5 = selected.filter(t6);
    $[7] = selected;
    $[8] = suggestedSet;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const selectedPresets = t5;
  let t6;
  if ($[12] !== atLimit || $[13] !== max || $[14] !== onChange || $[15] !== selected || $[16] !== suggested) {
    t6 = title => {
      const trimmed = title.trim();
      if (!trimmed || atLimit) {
        return;
      }
      if (selected.some(value => value.toLowerCase() === trimmed.toLowerCase())) {
        return;
      }
      const preset = suggested.find(value_0 => value_0.toLowerCase() === trimmed.toLowerCase());
      const next = [...selected, preset ?? trimmed];
      onChange(typeof max === "number" ? next.slice(0, max) : next);
    };
    $[12] = atLimit;
    $[13] = max;
    $[14] = onChange;
    $[15] = selected;
    $[16] = suggested;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const add = t6;
  let t7;
  if ($[18] !== onChange || $[19] !== selected) {
    t7 = tag_1 => {
      onChange(selected.filter(value_1 => value_1 !== tag_1));
    };
    $[18] = onChange;
    $[19] = selected;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const remove = t7;
  if (disabled) {
    const t8 = disabledText || "Pick an option above to see suggestions.";
    let t9;
    if ($[21] !== t8) {
      t9 = <Box bg="colorPalette.solid/5" borderRadius="md" padding={4}><Text color="colorPalette.fg/60" fontSize="sm">{t8}</Text></Box>;
      $[21] = t8;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    return t9;
  }
  let t8;
  if ($[23] !== suggestedLabel) {
    t8 = <Text color="colorPalette.fg/60" textStyle="labelXs">{suggestedLabel}</Text>;
    $[23] = suggestedLabel;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== atLimit || $[26] !== max || $[27] !== selected.length) {
    t9 = typeof max === "number" && <Text color={atLimit ? "orange.fg" : "colorPalette.fg/50"} fontSize="xs">{selected.length}/{max} selected</Text>;
    $[25] = atLimit;
    $[26] = max;
    $[27] = selected.length;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t8 || $[30] !== t9) {
    t10 = <HStack gap={2} justify="space-between" wrap="wrap">{t8}{t9}</HStack>;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== suggested) {
    t11 = suggested.map(_temp);
    $[32] = suggested;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== customTags || $[35] !== max || $[36] !== onChange) {
    t12 = options => {
      const nextPresets = options.map(_temp2);
      const next_0 = [...nextPresets, ...customTags];
      onChange(typeof max === "number" ? next_0.slice(0, max) : next_0);
    };
    $[34] = customTags;
    $[35] = max;
    $[36] = onChange;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== selectedPresets || $[39] !== t11 || $[40] !== t12) {
    t13 = <Wrap gap={2}><SelectableButtons options={t11} selectableButtonProps={PRESET_TAG_CHIP_PROPS} value={selectedPresets} onChange={t12} /></Wrap>;
    $[38] = selectedPresets;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== t10 || $[43] !== t13) {
    t14 = <VStack align="stretch" gap={2}>{t10}{t13}</VStack>;
    $[42] = t10;
    $[43] = t13;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== add || $[46] !== addHelperText || $[47] !== addLabel || $[48] !== atLimit || $[49] !== renderCombobox) {
    t15 = renderCombobox && <Field.Root>{addLabel && <Field.Label>{addLabel}</Field.Label>}{renderCombobox({
        add,
        atLimit
      })}{addHelperText && <Field.HelperText>{addHelperText}</Field.HelperText>}</Field.Root>;
    $[45] = add;
    $[46] = addHelperText;
    $[47] = addLabel;
    $[48] = atLimit;
    $[49] = renderCombobox;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  let t16;
  if ($[51] !== addedLabel || $[52] !== customTags || $[53] !== remove) {
    t16 = customTags.length > 0 && <VStack align="stretch" gap={2}><Text color="colorPalette.fg/60" textStyle="labelXs">{addedLabel}</Text><Wrap gap={2}>{customTags.map(tag_3 => <Badge key={tag_3} colorPalette="orange" paddingY={1} variant="subtle">{tag_3}<IconButton aria-label={`Remove ${tag_3}`} marginLeft={1} minWidth="auto" size="2xs" variant="plain" onClick={() => remove(tag_3)}><Icon boxSize={3}><LuX /></Icon></IconButton></Badge>)}</Wrap></VStack>;
    $[51] = addedLabel;
    $[52] = customTags;
    $[53] = remove;
    $[54] = t16;
  } else {
    t16 = $[54];
  }
  let t17;
  if ($[55] !== t14 || $[56] !== t15 || $[57] !== t16) {
    t17 = <VStack align="stretch" gap={4}>{t14}{t15}{t16}</VStack>;
    $[55] = t14;
    $[56] = t15;
    $[57] = t16;
    $[58] = t17;
  } else {
    t17 = $[58];
  }
  return t17;
};
function _temp(tag_2) {
  return {
    key: tag_2,
    title: tag_2
  };
}
function _temp2(option) {
  return option.key;
}